import LostPassword from "../components/Login/LostPassword";
import { useTrads } from "../contexts/trads/useTrads";
import "./LoginForm.scss"
function LostPage (){
    const {translate}=useTrads();
    return (
        <div className="login-form">
            <h4 ><a href="/"><img src="/assets/logo-tiny.png" width="50" height="50" alt="push asso" /></a> {translate('page_title_lost')}</h4>
    
            <LostPassword />
        </div>
    )
}

export default LostPage;